var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnglish = function SvgEnglish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "english_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#english_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.01 40h51.52c1.657-.094 2.99-1.479 2.99-3.156V3.156A3.163 3.163 0 0 0 45.365 0h-51.23A3.163 3.163 0 0 0-9 3.156v33.677A3.181 3.181 0 0 0-6.01 40Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73 23.99V40h8V23.99H48.5v-8H23.73V0h-8v15.99H-9v8h24.73Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.396 12.948V0h18.99a3.174 3.174 0 0 1 2.895 2L26.396 12.948ZM26.396 27.052V40H45.51a3.196 3.196 0 0 0 2.771-2L26.396 27.052ZM13.063 27.052V40H-6.01a3.17 3.17 0 0 1-2.771-2.02l21.844-10.928ZM13.063 12.948V0H-5.885a3.166 3.166 0 0 0-2.896 2.021l21.844 10.927Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.5 3.386-19.844 9.948h4.438L48.5 5.625v-2.24ZM10.802 26.667H6.365L-9 34.354v2.24l19.844-9.927h-.042ZM1.958 13.344h4.438L-9 5.635v2.23l10.958 5.479ZM37.49 26.656h-4.438l15.448 7.74v-2.23l-11.01-5.51Z",
    fill: "#C8102E"
  }))));
};
export default SvgEnglish;